import React, { useState } from "react";
import CommonDialog from "./CommonDialog";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Stack,
} from "@mui/material";
import DialogHeader from "../DialogHeader";

const PdfSummaryPreviewDialog = ({
  open = false,
  excel = false,
  allSelected = false,
  handleClose = () => {},
  data,
  handleExportPdf,
  setSelectedOptionsForPdf,
  selectedOptionsForPdf,
}) => {
  const handleCheckboxChangeForPdf = (option, isChecked) => {
    if (isChecked) {
      setSelectedOptionsForPdf((prevSelectedOptions) => [
        ...prevSelectedOptions,
        option,
      ]);
    } else {
      setSelectedOptionsForPdf((prevSelectedOptions) =>
        prevSelectedOptions.filter(
          (selectedOption) => selectedOption !== option
        )
      );
    }
  };

  const handleSelectAllChange = (isChecked) => {
    if (isChecked) {
      setSelectedOptionsForPdf(data);
    } else {
      setSelectedOptionsForPdf([]);
    }
  };

  return (
    <>
      {/* Dialog for selecting options for exporting pdf*/}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { minWidth: "400px" },
        }}
      >
        <DialogHeader
          title={`${excel ? "Excel" : "PDF"} Export Options`}
          handleClose={handleClose}
        />
        <DialogContent>
          {allSelected && (
            <Box sx={{ mb: 2 }}>
              <Stack direction="row">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptionsForPdf.length === data.length}
                      onChange={(e) => handleSelectAllChange(e.target.checked)}
                    />
                  }
                  label="Select All"
                />
              </Stack>
            </Box>
          )}
          <Box>
            {data?.map((option) => (
              <Stack direction="row" key={option}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptionsForPdf.includes(option)}
                      onChange={(e) =>
                        handleCheckboxChangeForPdf(option, e.target.checked)
                      }
                    />
                  }
                  label={option}
                />
              </Stack>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{ mb: 1 }}
            onClick={() => {
              handleExportPdf();
              handleClose();
            }}
          >
            DownLoad
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PdfSummaryPreviewDialog;
